const actionTypeIdentifier = '670BF8E5-776C-406A-A714-984C5025E947'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-INTL-ROAMING-ACCESS-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-INTL-ROAMING-ACCESS-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-INTL-ROAMING-ACCESS-RESET-LOADING-${actionTypeIdentifier}`;
export const getInternationalRequest = `GET-ALL-WIRELESS-INTL-ROAMING-REQUEST${actionTypeIdentifier}`;

export const wirelessIntlRoamingAccessModel = {
    circuitCode: ''
    , circuitId: 0
    , startDate: ''
    , endDate: ''
    , businessJustification: ''
    , countriesToBeVisited: ''
    , additionalInformation: ''
}
